export default __webpack_public_path__ + "static/media/php.2bf77be6.svg";